import {Button, Space} from "antd";
import {StyledWidgetInfoBlock, StyledWidgetWrapper} from "../widget.style";
import {DownloadOutlined} from "@ant-design/icons";

type CanvaTemplateWidgetProps = {
  url?: string;
};

export function CanvaTemplateWidget({url}: CanvaTemplateWidgetProps) {
  return (
    <StyledWidgetWrapper>
      {/* <h2 className="widget-heading">Free templates 🎨</h2> */}
      <h2 className="widget-heading">Free cover image templates</h2>
      <div className="widget-card">
        <Space direction="vertical" size={12} style={{display: "flex"}}>
          <StyledWidgetInfoBlock style={{background: "#DFFCD8", color: "#1C1726"}}>
            <p>Download free Canva templates for your cover image</p>
          </StyledWidgetInfoBlock>
          <Button
            href={url}
            block
            icon={<DownloadOutlined style={{fontSize: "1.6rem"}} />}
            size="small"
            target="_blank"
          >
            <span>Download free templates</span>
          </Button>
        </Space>
      </div>
    </StyledWidgetWrapper>
  );
}
